import React, {
  PropTypes as T,
  Component,
} from 'react';
import radium from 'radium';
import * as DetectionActions from '../../actions/Detection.js';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Calendar from '../../libs/Calendar.js';
import DatePicker from 'rc-calendar/lib/Picker';
import moment from 'moment';

const styles = {
  wrap: {
    display: 'none',
    width: '100%',
    height: '100%',
    position: 'fixed',
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, .38)',
  },
  shown: {
    display: 'block',
  },
  container: {
    display: 'flex',
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    overflow: 'auto',
  },
  form: {
    width: 585,
    height: 399,
    backgroundColor: '#eee',
    position: 'relative',
    overflow: 'auto',
    marginBottom: 90,
    marginTop: 90,
    borderRadius: 10,
  },
  contentWrap: {
    padding: 20,
    textAlign: 'center',
  },
  title: {
    display: 'block',
    fontSize: 18,
  },
  inputWrap: {
    margin: '10px 0',
    display: 'flex',
    justifyContent: 'center',
  },
  label: {
    textAlign: 'right',
    width: 100,
    color: '#4A4A4A',
    lineHeight: '30px',
    '@media (max-width: 767px)': {
      textAlign: 'center',
    },
  },
  input: {
    flex: 1,
    maxWidth: 300,
    color: '#4A4A4A',
    border: 0,
    borderRadius: 3,
    backgroundColor: 'white',
    outline: 'none',
    lineHeight: '30px',
    padding: '0px 10px',
  },
  bottomWrap: {
    width: '100%',
    textAlign: 'center',
    position: 'absolute',
    bottom: 0,
    lineHeight: '52px',
    padding: 0,
    textDecoration: 'none',
    color: '#4A4A4A',
    borderTop: '1px solid #D8D8D8',
    letterSpacing: 1.5,
    fontSize: 24,
    backgroundColor: 'transparent',
    borderLeft: 0,
    borderRight: 0,
    borderBottom: 0,
    cursor: 'pointer',
  },
  closeBtn: {
    position: 'absolute',
    right: 10,
    color: 'white',
    backgroundColor: 'transparent',
    border: 0,
    outline: 'none',
    lineHeight: '42px',
    padding: 0,
    fontSize: 24,
    cursor: 'pointer',
  },
  h1: {
    position: 'relative',
    backgroundColor: '#fed312',
    margin: 0,
    color: 'white',
    fontSize: 24,
    lineHeight: '42px',
    textAlign: 'center',
    letterSpacing: 2,
  },
  textWrap: {
    maxWidth: 490,
    margin: '0 auto',
  },
  text: {
    outline: 'none',
    border: 0,
    backgroundColor: 'transparent',
    fontSize: 15,
  },
  rule: {
    color: '#004D9F',
    cursor: 'pointer',
  },
};

class DetectionSendResultModal extends Component {
  constructor(props) {
    super(props);

    const {
      birthday,
    } = this.props;

    this.state = {
      playing: false,
      volume: 50,
      muted: false,
      panStartX: null,
      barUnit: 3,
      lastTime: 0,
      newBirthday: birthday ? moment(birthday) : moment(),
    };
  }

  componentDidMount() {

  }

  submitResult() {
    const {
      testerRefs,
      phoneRefs,
      mobilePhoneRefs,
      checkboxRefs,
    } = this.refs;

    const {
      tester,
      phone,
      birthday,
      mobilePhone,
      createMember,
      sendResult,
      left,
      right,
      customerId,
    } = this.props;

    const {
      newBirthday,
    } = this.state;

    // check format on input
    const mobilePhoneRegxp = /^09[0-9]{8}$/;
    const phoneRegxp = /^[0-9]{9,10}$/;

    if (testerRefs.value.length >= 20) {
      alert('姓名長度限制為 20 字元');
      return;
    }
    if (!mobilePhoneRegxp.test(mobilePhoneRefs.value)) {
      alert('電話格式有誤');
      return;
    }
    if (phoneRefs.value && !phoneRegxp.test(phoneRefs.value)) {
      alert('家用電話格式有誤');
      return;
    }
    if (!newBirthday.isValid()) {
      alert('生日格式錯誤');
      return;
    }
    if (!checkboxRefs.checked) {
      alert('請勾選同意聲明');
      return;
    }

    if (testerRefs.value === tester &&
        phoneRefs.value === phone &&
        !(newBirthday > moment(birthday)) &&
        !(newBirthday < moment(birthday)) &&
        mobilePhoneRefs.value === mobilePhone &&
        customerId) {
      if (left > 55 || right > 55) {
        sendResult(customerId, 'above');
        return;
      }

      sendResult(customerId, 'below');
      return;
    }

    createMember(
      testerRefs.value,
      phoneRefs.value,
      newBirthday,
      mobilePhoneRefs.value,
      left,
      right);
    return;
  }

  render() {
    const {
      isShownSendFormModal,
      closeSendFormModal,
      openRuleModal,
      tester,
      phone,
      mobilePhone,
    } = this.props;

    const {
      newBirthday,
    } = this.state;

    return (
      <div style={[styles.wrap, isShownSendFormModal && styles.shown]}>
        <div style={styles.container}>
          <div style={styles.form}>
            <h1 style={styles.h1}>
              發送聽檢結果
              <button onClick={() => closeSendFormModal()} className="fa fa-times" style={styles.closeBtn} />
            </h1>
            <div style={styles.contentWrap}>
              <span style={styles.title}>客戶基本資料</span>
              <div style={styles.inputWrap}>
                <label style={styles.label}>姓名：</label>
                <input
                  ref="testerRefs"
                  style={styles.input}
                  type="text"
                  placeholder="輸入姓名，長度限制為 20 字元"
                  defaultValue={tester} />
              </div>
              <div style={styles.inputWrap}>
                <label style={styles.label}>電話：</label>
                <input
                  ref="mobilePhoneRefs"
                  style={styles.input}
                  type="text"
                  placeholder="0912345678"
                  defaultValue={mobilePhone} />
              </div>
              <div style={styles.inputWrap}>
                <label style={styles.label}>生日：</label>
                <DatePicker
                  animation="slide-up"
                  calendar={Calendar}
                  value={newBirthday}
                  children={({ value }) => (
                    <input
                      style={styles.input}
                      placeholder="選擇日期"
                      readOnly
                      tabIndex="-1"
                      className="ant-calendar-picker-input ant-input"
                      value={value && moment(value).format('YYYY-MM-DD') || ''} />
                  )}
                  onChange={(d) => this.setState({ newBirthday: d })} />

              </div>
              <div style={styles.inputWrap}>
                <label style={styles.label}>市話(選填)：</label>
                <input
                  ref="phoneRefs"
                  style={styles.input}
                  type="text"
                  placeholder="範例: 0212345678"
                  defaultValue={phone} />
              </div>
              <div style={styles.textWrap}>
                <input ref="checkboxRefs" type="checkbox" style={styles.checkbox} />
                <span style={styles.text}>若您已詳讀本公司</span>
                <button
                  style={[styles.text, styles.rule]}
                  onClick={() => openRuleModal()}>『蒐集、處理及利用個人資料告知事項』</button>
                <span style={styles.text}>(請詳讀)並同意以上聲明之內容及方式，請勾選本聲明後按『送出』</span>
              </div>
            </div>
            <button onClick={() => this.submitResult()} style={styles.bottomWrap}>送出</button>
          </div>
        </div>
      </div>
    );
  }
}

DetectionSendResultModal.propTypes = {
  isShownSendFormModal: T.bool,
  closeSendFormModal: T.func,
  createMember: T.func,
  sendResult: T.func,
  openRuleModal: T.func,
  tester: T.string,
  phone: T.string,
  birthday: T.string,
  mobilePhone: T.string,
  left: T.number,
  right: T.number,
  customerId: T.string,
};

export default connect(
  state => ({
    isShownSendFormModal: state.Detection.isShownSendFormModal,
    tester: state.Auth.tester,
    phone: state.Auth.phone,
    birthday: state.Auth.birthday,
    mobilePhone: state.Auth.mobilePhone,
    customerId: state.Auth.customerId,
  }),
  dispatch => bindActionCreators(DetectionActions, dispatch),
)(radium(DetectionSendResultModal));



// WEBPACK FOOTER //
// ./containers/Detections/DetectionSendResultModal.js